import { ReactComponent as EmptyPanelDroneIcon } from '@assets/components/panel/notification/empty-panel-drone-icon.svg';
import { Center, For, Text, VStack } from '@chakra-ui/react';
import { DraggablePanel } from '@components/ui/draggable';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectNeutralMonitoringSensorWithSectors } from '@redux/situation/monitoring.selectors';
import { FormattedMessage } from 'react-intl';

import { PopupPositionData } from '@/types/popup.types';

import NeutralInfoCard from './NeutralInfoCard';

export default function NeutralInfo({ mapConstraintsRef, top, left, onClose }: Readonly<PopupPositionData>) {
  const monitoringSensors = useSelectorWithReplayMode(selectNeutralMonitoringSensorWithSectors);

  const width = 500;

  return (
    <DraggablePanel.Root constraintsRef={mapConstraintsRef} top={top} left={left}>
      <DraggablePanel.Header onClose={onClose}>
        <FormattedMessage id="neutralInfo.title" />
      </DraggablePanel.Header>
      <DraggablePanel.Body width={width} maxHeight={518}>
        <VStack
          gap={0.25}
          backgroundColor="neutral.900"
          flex={1}
          overflow="hidden"
          height="100%"
          overflowY="auto"
          className="map-panel-scrollbar"
        >
          <For
            each={monitoringSensors}
            fallback={
              <Center width="100%" flex={1} paddingY={4}>
                <VStack width="100%">
                  <EmptyPanelDroneIcon />
                  <Text textStyle="md" color="neutral.200">
                    <FormattedMessage id="neutralInfo.empty" />
                  </Text>
                </VStack>
              </Center>
            }
          >
            {(monitoringSensor) => (
              <NeutralInfoCard monitoringSensor={monitoringSensor} top={top} left={left + width + 20} />
            )}
          </For>
        </VStack>
      </DraggablePanel.Body>
    </DraggablePanel.Root>
  );
}
